import Loadable from 'react/components/loadable';

const BulkAddAttendeesModal = Loadable({
  loader: () => import('../../../pages/event_defaults/bulk_add_event/bulk_add_attendees_modal'),
  type: 'block',
});

angular.module('gym').value('BulkAddAttendeesModal', BulkAddAttendeesModal);
